// filepath: /c:/Users/magnu/Desktop/investorverden/Investorverden/src/pages/terms-and-policy.jsx
import React from "react";
import styles from "../css/style";
import { Navbar, Footer } from "../components/LandingPage";

const TermsAndPolicy = () => {
  return (
    <>
      <div className={`${styles.paddingX} ${styles.flexCenter} w-full overflow-hidden`}>
        <div className={`${styles.boxWidth}`}>
          {/* Pass onlyAuth prop to display only Log ind and Opret bruger */}
          <Navbar onlyAuth />
        </div>
      </div>
      <div className="bg-primary w-full overflow-hidden pt-[150px]">
        <div className={`bg-primary ${styles.paddingX} ${styles.flexCenter}`}>
          <div className={`${styles.boxWidth}`}>
            <h1 className="text-3xl font-bold mb-6 text-white">
              Vilkår og Betingelser for Investor Verden
            </h1>
            <p className="mb-4 text-dimWhite">
              Velkommen til Investorverden.dk. Ved at tilgå og bruge vores hjemmeside accepterer du at være bundet af følgende vilkår og betingelser. Læs venligst disse grundigt igennem, inden du bruger vores tjenester.
            </p>
            <h2 className="text-2xl font-bold mb-4 text-white">1. Accept af Vilkår</h2>
            <p className="mb-4 text-dimWhite">
              Ved at oprette en konto eller bruge vores tjenester accepterer du at overholde disse vilkår og politikker. Hvis du ikke accepterer disse vilkår, skal du undlade at bruge vores platform.
            </p>
            <h2 className="text-2xl font-bold mb-4 text-white">2. Tjenester</h2>
            <p className="mb-4 text-dimWhite">
              Vores platform tilbyder analyseværktøjer til aktiemarkedet, der inkluderer historiske data, fremtidige estimeringer og andre finansielle funktioner. Vi giver ingen garantier for rigtigheden, fuldstændigheden eller pålideligheden af de data, der præsenteres.
            </p>
            <h2 className="text-2xl font-bold mb-4 text-white">3. Ansvarsfraskrivelse</h2>
            <p className="mb-4 text-dimWhite">
              Al information og analyse leveret af vores platform er til informationsformål. Vi tilbyder ikke finansiel rådgivning, og brugere bør konsultere en professionel rådgiver, inden de træffer investeringsbeslutninger. Investeringer er forbundet med risiko, og vi påtager os intet ansvar for tab eller skader som følge af brugen af vores tjenester.
            </p>
            <h2 className="text-2xl font-bold mb-4 text-white">4. Brugerforpligtelser</h2>
            <p className="mb-4 text-dimWhite">
              Du må ikke misbruge vores platform ved at distribuere skadelig software eller udføre ulovlige aktiviteter.
            </p>
            <p className="mb-4 text-dimWhite">
              Du er ansvarlig for at sikre, at dine loginoplysninger er sikre.
            </p>
            <p className="mb-4 text-dimWhite">
              Du må ikke reproducere, kopiere eller videresælge vores indhold uden skriftlig tilladelse.
            </p>
            <h2 className="text-2xl font-bold mb-4 text-white">5. Persondata og Privatliv</h2>
            <p className="mb-4 text-dimWhite">
              Din brug af platformen er underlagt vores privatlivspolitik. Vi indsamler og behandler dine data i overensstemmelse med GDPR og andre relevante databeskyttelseslove.
            </p>
            <h2 className="text-2xl font-bold mb-4 text-white">Privatlivspolitik</h2>
            <p className="mb-4 text-dimWhite">
              Denne privatlivspolitik forklarer, hvordan vi indsamler, bruger og beskytter dine personlige oplysninger.
            </p>
            <h3 className="text-xl font-bold mb-4 text-white">1. Data, vi indsamler</h3>
            <p className="mb-4 text-dimWhite">
              Vi indsamler følgende typer data:
            </p>
            <ul className="list-disc list-inside mb-4 text-dimWhite">
              <li>Personlige oplysninger, som du selv angiver (navn, e-mailadresse, brugernavn).</li>
              <li>Brugsdata, der automatisk indsamles, når du interagerer med vores platform (IP-adresse, browserdata, besøgsmønstre).</li>
            </ul>
            <h3 className="text-xl font-bold mb-4 text-white">2. Hvordan vi bruger dine data</h3>
            <p className="mb-4 text-dimWhite">
              Dine oplysninger bruges til:
            </p>
            <ul className="list-disc list-inside mb-4 text-dimWhite">
              <li>At forbedre brugeroplevelsen.</li>
              <li>At levere personaliseret indhold og anbefalinger.</li>
              <li>At sende opdateringer og vigtig information om platformen.</li>
            </ul>
            <h3 className="text-xl font-bold mb-4 text-white">3. Deling af data</h3>
            <p className="mb-4 text-dimWhite">
              Vi deler ikke dine data med tredjepart uden dit samtykke, medmindre det er påkrævet ved lov.
            </p>
            <h3 className="text-xl font-bold mb-4 text-white">4. Datasikkerhed</h3>
            <p className="mb-4 text-dimWhite">
              Vi bruger avancerede sikkerhedsforanstaltninger for at beskytte dine data mod uautoriseret adgang, tab eller misbrug.
            </p>
            <h3 className="text-xl font-bold mb-4 text-white">5. Dine rettigheder</h3>
            <p className="mb-4 text-dimWhite">
              Du har ret til:
            </p>
            <ul className="list-disc list-inside mb-4 text-dimWhite">
              <li>At få adgang til de oplysninger, vi har om dig.</li>
              <li>At bede om rettelse eller sletning af dine data.</li>
              <li>At trække dit samtykke til databehandling tilbage.</li>
            </ul>
            <h2 className="text-2xl font-bold mb-4 text-white">6. Ændringer i Vilkår og Politik</h2>
            <p className="mb-4 text-dimWhite">
              Vi forbeholder os retten til at ændre disse vilkår og politikker. Eventuelle ændringer vil blive offentliggjort på vores hjemmeside, og fortsat brug af platformen betragtes som accept af disse ændringer.
            </p>
            <h2 className="text-2xl font-bold mb-4 text-white">7. Refunderings Politik</h2>
            <p className="mb-4 text-dimWhite">
              Alle betalinger, du foretager til virksomheden, er endelige. Der udstedes ingen refusion. I tilfælde af uenighed om identiteten af ​​den person, der pådrager sig en afgift, vil afgiften blive anset for påløbet af den person, i hvis navn kontoen er registreret. Alle tvister vedrørende gebyrer og tilbagebetalinger er underlagt bestemmelserne i denne aftale.
            </p>
            <h2 className="text-2xl font-bold mb-4 text-white">8. Kontakt</h2>
            <p className="mb-4 text-dimWhite">
              Hvis du har spørgsmål eller bekymringer vedrørende disse vilkår eller privatlivspolitikken, kan du kontakte os via e-mail: <a href="mailto:info@investorverden.dk" className="text-white underline">info@investorverden.dk</a>.
            </p>
            <p className="mb-4 text-dimWhite">
              Tak fordi du bruger Investor Verden!
            </p>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndPolicy;